/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { getOutputValue } from './useInput.mjs';
import '../_chunks/dep-89b33ff6.mjs';
import '../_chunks/dep-6bcce672.mjs';
import 'vue';
import '../form/const.mjs';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../_chunks/dep-97c71289.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-b333ab93.mjs';
import '../_chunks/dep-4efc69ee.mjs';
import '../hooks/slot.mjs';
import '../_chunks/dep-0d1bd08c.mjs';
import '../hooks/tnode.mjs';
import '../_chunks/dep-0a6fd248.mjs';
import '../_chunks/dep-7ad89920.mjs';
import '../_chunks/dep-c5d88cfe.mjs';
import '../_chunks/dep-36563716.mjs';
import '../_chunks/dep-8049d2e0.mjs';
import '../_chunks/dep-b1013215.mjs';
import '../_chunks/dep-91fc304f.mjs';
import '../_chunks/dep-17446155.mjs';
import '../_chunks/dep-8747fcf0.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ec227f3f.mjs';
import '../_chunks/dep-18bb982b.mjs';
import '../_chunks/dep-25d66c95.mjs';
import '../_chunks/dep-372265bb.mjs';
import '../_chunks/dep-ae08d6c4.mjs';
import '../_chunks/dep-d940e2da.mjs';
import '../_chunks/dep-e50fa7b0.mjs';
import '../_chunks/dep-c57d8117.mjs';
import '../_chunks/dep-c7e4942d.mjs';
import '../_chunks/dep-5f6c8826.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-493c38ce.mjs';
import '../_chunks/dep-b56b2dc0.mjs';
import '../_chunks/dep-77f634fb.mjs';
import '../_chunks/dep-28ae3cda.mjs';
import '../_chunks/dep-7211604f.mjs';
import '../_chunks/dep-75df64b1.mjs';
import '../_chunks/dep-48b9a098.mjs';
import '../_chunks/dep-52c1d6a9.mjs';
import '../_chunks/dep-6043e9fc.mjs';
import '../_chunks/dep-3a045465.mjs';
import '../_chunks/dep-53dc0ac1.mjs';
import '../_chunks/dep-b6b4eaa3.mjs';
import '../_chunks/dep-881cffb7.mjs';
import '../_chunks/dep-436b338d.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-2d31a683.mjs';
import '../_chunks/dep-3ddc95d0.mjs';
import '../config-provider/type.mjs';
import '../hooks/useCommonClassName.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useRipple.mjs';
import '../utils/set-style.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../_chunks/dep-a26b9c60.mjs';
import '../hooks/useVModel.mjs';
import '../hooks/useImagePreviewUrl.mjs';
import '../_common/js/upload/utils.mjs';
import '../_common/js/log/log.mjs';
import '../form/hooks.mjs';
import './useLengthLimit.mjs';
import '../_common/js/log/index.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-f7837681.mjs';
import '../_chunks/dep-9c7a32ff.mjs';
import '../_chunks/dep-c45cdd10.mjs';
import '../_chunks/dep-ce88e3c0.mjs';
import '../_chunks/dep-a432d90f.mjs';

function useInputEventHandler(props, isHover) {
  var handleKeydown = function handleKeydown(e) {
    if (props.disabled) return;
    var code = e.code;
    var tmpValue = getOutputValue(e.currentTarget.value, props.type);
    if (/enter/i.test(code) || /enter/i.test(e.key)) {
      var _props$onEnter;
      (_props$onEnter = props.onEnter) === null || _props$onEnter === void 0 || _props$onEnter.call(props, tmpValue, {
        e: e
      });
    } else {
      var _props$onKeydown;
      (_props$onKeydown = props.onKeydown) === null || _props$onKeydown === void 0 || _props$onKeydown.call(props, tmpValue, {
        e: e
      });
    }
  };
  var handleKeyUp = function handleKeyUp(e) {
    var _props$onKeyup;
    if (props.disabled) return;
    var tmpValue = getOutputValue(e.currentTarget.value, props.type);
    (_props$onKeyup = props.onKeyup) === null || _props$onKeyup === void 0 || _props$onKeyup.call(props, tmpValue, {
      e: e
    });
  };
  var handleKeypress = function handleKeypress(e) {
    var _props$onKeypress;
    if (props.disabled) return;
    var tmpValue = getOutputValue(e.currentTarget.value, props.type);
    (_props$onKeypress = props.onKeypress) === null || _props$onKeypress === void 0 || _props$onKeypress.call(props, tmpValue, {
      e: e
    });
  };
  var onHandlePaste = function onHandlePaste(e) {
    var _props$onPaste;
    if (props.disabled) return;
    var clipData = e.clipboardData || window.clipboardData;
    (_props$onPaste = props.onPaste) === null || _props$onPaste === void 0 || _props$onPaste.call(props, {
      e: e,
      pasteValue: clipData === null || clipData === void 0 ? void 0 : clipData.getData("text/plain")
    });
  };
  var mouseEvent = function mouseEvent(v) {
    return isHover.value = v;
  };
  var onHandleMousewheel = function onHandleMousewheel(e) {
    var _props$onWheel;
    return (_props$onWheel = props.onWheel) === null || _props$onWheel === void 0 ? void 0 : _props$onWheel.call(props, {
      e: e
    });
  };
  var onInputMouseenter = function onInputMouseenter(e) {
    var _props$onMouseenter;
    mouseEvent(true);
    (_props$onMouseenter = props.onMouseenter) === null || _props$onMouseenter === void 0 || _props$onMouseenter.call(props, {
      e: e
    });
  };
  var onInputMouseleave = function onInputMouseleave(e) {
    var _props$onMouseleave;
    mouseEvent(false);
    (_props$onMouseleave = props.onMouseleave) === null || _props$onMouseleave === void 0 || _props$onMouseleave.call(props, {
      e: e
    });
  };
  return {
    isHover: isHover,
    handleKeydown: handleKeydown,
    handleKeyUp: handleKeyUp,
    handleKeypress: handleKeypress,
    onHandlePaste: onHandlePaste,
    onHandleMousewheel: onHandleMousewheel,
    onInputMouseenter: onInputMouseenter,
    onInputMouseleave: onInputMouseleave
  };
}

export { useInputEventHandler as default };
//# sourceMappingURL=useInputEventHandler.mjs.map
